// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"77d1c22a","81":"cd76645f","200":"5ca3db3d","539":"467865a2"}[chunkId] + ".chunk.js";
};